<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import ControlScenePlay from 'src/components/Controls/Scene/ControlScenePlay.svelte';
	import ControlSceneEnable from 'src/components/Controls/Scene/ControlSceneEnable.svelte';

	export let scene;
	// Accept extra props passed from parent via svelte:component
	export let id;
	export let whens;
	export let thens;
	export let elses;
	export let active_time;
	export let run_on_save;
	export let scene_enable_val;
	export let allowed_for_3rd_party;
	export let duplicateInfo;
</script>

<SidepanelContent>
	<div slot="staticBottom">
		{#if scene}
			<ControlScenePlay item={scene} variant="drawer" />
			<ControlSceneEnable item={scene} variant="drawer" />
		{/if}
	</div>
</SidepanelContent>
